import { z } from 'zod';

export const textComponentSchema = z.object({
  componentType: z.literal('text'),
  text: z.string(),
});

export const userActionComponentSchema = z.object({
  componentType: z.literal('user_action'),
  actions: z.array(z.string()),
});

export const propertyAttributesSchema = z.object({
  attributeType: z.enum(['bedrooms', 'bathrooms', 'car_spaces']),
  value: z.string(),
});

export const propertyTileComponentSchema = z.object({
  componentType: z.literal('property_tile'),
  propertyId: z.string(),
  address: z.string(),
  imageUrl: z.string().nullable(),
  attributes: z.array(propertyAttributesSchema),
  price: z.string().nullable(),
  propertyStatus: z.enum(['for_sale', 'for_rent', 'off_market', 'sold']).nullable(),
});

export const propertySelectorTileComponentSchema = z.object({
  componentType: z.literal('property_selector_tile'),
  propertyId: z.string(),
  address: z.string(),
  imageUrl: z.string().nullable(),
  attributes: z.array(propertyAttributesSchema),
  price: z.string().nullable(),
  propertyStatus: z.enum(['for_sale', 'for_rent', 'off_market', 'sold']).nullable(),
});

export const propertySelectorComponentSchema = z.object({
  componentType: z.literal('property_selector'),
  properties: z.array(propertySelectorTileComponentSchema),
  actions: z.array(z.string()),
});

export const propertyTilesComponentSchema = z.object({
  componentType: z.literal('property_tiles'),
  properties: z.array(propertyTileComponentSchema),
});

export const comparisonTableColumnSchema = z.object({
  propertyId: z.string(),
  imageUrl: z.string().nullable(),
  address: z.string(),
  price: z.string(),
  propertyType: z.string(),
  bedrooms: z.string(),
  bathrooms: z.string(),
  carSpaces: z.string(),
  landSize: z.string(),
  buildingArea: z.string(),
  soldDate: z.string(),
});

export const comparisonTableComponentSchema = z.object({
  componentType: z.literal('comparison_table'),
  properties: z.array(comparisonTableColumnSchema),
});

export const clientActionSchema = z.object({
  agentMessage: z.string(),
  text: z.string(),
});

export const clientActionComponentSchema = z.object({
  componentType: z.literal('client_action'),
  actions: z.array(clientActionSchema),
});

export const uiComponentSchema = z.union([
  textComponentSchema,
  userActionComponentSchema,
  propertyTileComponentSchema,
  propertyTilesComponentSchema,
  propertySelectorComponentSchema,
  comparisonTableComponentSchema,
  clientActionComponentSchema,
]);
